export default __webpack_public_path__ + "static/26-2c1414c7dd1339d82bc820ee1edcfab2.png";